module.exports = __webpack_public_path__ + "img/report.fe2e0ac6.svg";